export default "__VITE_ASSET__Ck_I1e$u__"